// @flow

import React from "react";
import { type FormApi } from "final-form";

import FinancingCoronaLoan from "./FinancingCoronaLoan";
import FinancingLoan from "./FinancingLoan";
import FinancingLeasing from "./FinancingLeasing";
import FinancingOther from "./FinancingOther";
import FinancingOverdraft from "./FinancingOverdraft";
import FinancingShared from "./FinancingShared";
import FinancingFounder from "./FinancingFounder";
import FinancingMicroMezzanine from "./FinancingMicroMezzanine";
import FinancingEquity from "./FinancingEquity";

import {
  FINANCING_SUPPORT,
  FINANCING_PRODUCT,
  FINANCING_PRODUCT__LOAN,
  FINANCING_PRODUCT__LEASING,
  FINANCING_PRODUCT__OVERDRAFT,
  FINANCING_PRODUCT__EQUITY,
  FINANCING_PRODUCT__OTHER,
  FINANCING_PRODUCT__MICRO_MEZZANINE,
  FINANCING_PRODUCT__CORONA_LOAN,
  PURPOSE_KIND,
  PURPOSE_KIND__FINANCE_CHECK
} from "./formFields";
import { chooseType } from "../../data/dictionary";
import Section from "../../components/Section";

const financingTypes = {
  [FINANCING_PRODUCT__CORONA_LOAN]: FinancingCoronaLoan,
  [FINANCING_PRODUCT__LOAN]: FinancingLoan,
  [FINANCING_PRODUCT__LEASING]: FinancingLeasing,
  [FINANCING_PRODUCT__OVERDRAFT]: FinancingOverdraft,
  [FINANCING_PRODUCT__EQUITY]: FinancingEquity,
  [FINANCING_PRODUCT__MICRO_MEZZANINE]: FinancingMicroMezzanine,
  [FINANCING_PRODUCT__OTHER]: FinancingOther
};

export type FinancingProps = {
  handleSubmit: (values: {}, form: FormApi) => void,
  initialValues: {},
  isEstablishedEntrepreneur: boolean,
  site: "buba" | "bank" | "customer",
  type: "customer" | "bankAdvisor"
};

const Financing = ({
  initialValues,
  handleSubmit,
  isEstablishedEntrepreneur,
  site,
  type
}: FinancingProps) => {
  // Don't render for finance check inquiries (sync with PDF template)
  const purposeKind = initialValues[PURPOSE_KIND]?.[0]?.kind;
  const productKind = initialValues[FINANCING_PRODUCT];
  if ((!purposeKind && !productKind) || purposeKind === PURPOSE_KIND__FINANCE_CHECK) {
    return null;
  }

  const FinancingType = financingTypes[productKind] ?? financingTypes[FINANCING_PRODUCT__OTHER];

  const FinancingEstablished = () =>
    initialValues[FINANCING_SUPPORT] ? (
      <FinancingShared initialValues={initialValues} site={site} />
    ) : (
      <FinancingType
        handleSubmit={handleSubmit}
        initialValues={initialValues}
        site={site}
        type={type}
        isLocked
      />
    );

  return (
    <Section
      title={chooseType(site, type) && chooseType(site, type).financingSectionTitle}
      reducedMargin
      numbered
    >
      {isEstablishedEntrepreneur ? (
        FinancingEstablished()
      ) : (
        <FinancingFounder initialValues={initialValues} site={site} type={type} />
      )}
    </Section>
  );
};

export default Financing;
